export default [
  {
    'ine_region_code': '08',
    'ine_province_code': '02',
    'id': 1,
    'name_cadaster': 'ALBACETE',
    'name_es': 'Albacete',
    'name_ca': 'Albacete',
    'name_ine': 'Albacete'
  },
  {
    'ine_region_code': '10',
    'ine_province_code': '03',
    'id': 2,
    'name_cadaster': 'ALACANT',
    'name_es': 'Alicante',
    'name_ca': 'Alacant',
    'name_ine': 'Alicante/Alacant'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '04',
    'id': 3,
    'name_cadaster': 'ALMERIA',
    'name_es': 'Almería',
    'name_ca': 'Almeria',
    'name_ine': 'Almería'
  },
  {
    'ine_region_code': '16',
    'ine_province_code': '01',
    'id': 4,
    'name_cadaster': '',
    'name_es': 'Álava',
    'name_ca': 'Àlaba',
    'name_ine': 'Araba/Álava'
  },
  {
    'ine_region_code': '03',
    'ine_province_code': '33',
    'id': 5,
    'name_cadaster': 'ASTURIAS',
    'name_es': 'Asturias',
    'name_ca': 'Astúries',
    'name_ine': 'Asturias'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '05',
    'id': 6,
    'name_cadaster': 'AVILA',
    'name_es': 'Ávila',
    'name_ca': 'Àvila',
    'name_ine': 'Ávila'
  },
  {
    'ine_region_code': '11',
    'ine_province_code': '06',
    'id': 7,
    'name_cadaster': 'BADAJOZ',
    'name_es': 'Badajoz',
    'name_ca': 'Badajoz',
    'name_ine': 'Badajoz'
  },
  {
    'ine_region_code': '04',
    'ine_province_code': '07',
    'id': 8,
    'name_cadaster': 'ILLES BALEARS',
    'name_es': 'Baleares, Islas',
    'name_ca': 'Balears, Illes',
    'name_ine': 'Balears, Illes'
  },
  {
    'ine_region_code': '09',
    'ine_province_code': '08',
    'id': 9,
    'name_cadaster': 'BARCELONA',
    'name_es': 'Barcelona',
    'name_ca': 'Barcelona',
    'name_ine': 'Barcelona'
  },
  {
    'ine_region_code': '16',
    'ine_province_code': '48',
    'id': 10,
    'name_cadaster': '',
    'name_es': 'Vizcaya',
    'name_ca': 'Biscaia',
    'name_ine': 'Bizkaia'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '09',
    'id': 11,
    'name_cadaster': 'BURGOS',
    'name_es': 'Burgos',
    'name_ca': 'Burgos',
    'name_ine': 'Burgos'
  },
  {
    'ine_region_code': '11',
    'ine_province_code': '10',
    'id': 12,
    'name_cadaster': 'CACERES',
    'name_es': 'Cáceres',
    'name_ca': 'Càceres',
    'name_ine': 'Cáceres'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '11',
    'id': 13,
    'name_cadaster': 'CADIZ',
    'name_es': 'Cádiz',
    'name_ca': 'Cadis',
    'name_ine': 'Cádiz'
  },
  {
    'ine_region_code': '06',
    'ine_province_code': '39',
    'id': 14,
    'name_cadaster': 'CANTABRIA',
    'name_es': 'Cantabria',
    'name_ca': 'Cantàbria',
    'name_ine': 'Cantabria'
  },
  {
    'ine_region_code': '10',
    'ine_province_code': '12',
    'id': 15,
    'name_cadaster': 'CASTELLO',
    'name_es': 'Castellón',
    'name_ca': 'Castelló',
    'name_ine': 'Castellón/Castelló'
  },
  {
    'ine_region_code': '08',
    'ine_province_code': '13',
    'id': 16,
    'name_cadaster': 'CIUDAD REAL',
    'name_es': 'Ciudad Real',
    'name_ca': 'Ciutat Real',
    'name_ine': 'Ciudad Real'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '14',
    'id': 17,
    'name_cadaster': 'CORDOBA',
    'name_es': 'Córdoba',
    'name_ca': 'Còrdoba',
    'name_ine': 'Córdoba'
  },
  {
    'ine_region_code': '12',
    'ine_province_code': '15',
    'id': 18,
    'name_cadaster': 'A CORUÑA',
    'name_es': 'Coruña,A',
    'name_ca': 'Corunya, La',
    'name_ine': 'Coruña, A'
  },
  {
    'ine_region_code': '08',
    'ine_province_code': '16',
    'id': 19,
    'name_cadaster': 'CUENCA',
    'name_es': 'Cuenca',
    'name_ca': 'Conca',
    'name_ine': 'Cuenca'
  },
  {
    'ine_region_code': '16',
    'ine_province_code': '20',
    'id': 20,
    'name_cadaster': '',
    'name_es': 'Guipúzcoa',
    'name_ca': 'Guipúscoa',
    'name_ine': 'Gipuzkoa'
  },
  {
    'ine_region_code': '09',
    'ine_province_code': '17',
    'id': 21,
    'name_cadaster': 'GIRONA',
    'name_es': 'Gerona',
    'name_ca': 'Girona',
    'name_ine': 'Girona'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '18',
    'id': 22,
    'name_cadaster': 'GRANADA',
    'name_es': 'Granada',
    'name_ca': 'Granada',
    'name_ine': 'Granada'
  },
  {
    'ine_region_code': '08',
    'ine_province_code': '19',
    'id': 23,
    'name_cadaster': 'GUADALAJARA',
    'name_es': 'Guadalajara',
    'name_ca': 'Guadalajara',
    'name_ine': 'Guadalajara'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '21',
    'id': 24,
    'name_cadaster': 'HUELVA',
    'name_es': 'Huelva',
    'name_ca': 'Huelva',
    'name_ine': 'Huelva'
  },
  {
    'ine_region_code': '02',
    'ine_province_code': '22',
    'id': 25,
    'name_cadaster': 'HUESCA',
    'name_es': 'Huesca',
    'name_ca': 'Huesca',
    'name_ine': 'Huesca'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '23',
    'id': 26,
    'name_cadaster': 'JAEN',
    'name_es': 'Jaén',
    'name_ca': 'Jaén',
    'name_ine': 'Jaén'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '24',
    'id': 27,
    'name_cadaster': 'LEON',
    'name_es': 'León',
    'name_ca': 'Lleó',
    'name_ine': 'León'
  },
  {
    'ine_region_code': '09',
    'ine_province_code': '25',
    'id': 28,
    'name_cadaster': 'LLEIDA',
    'name_es': 'Lérida',
    'name_ca': 'Lleida',
    'name_ine': 'Lleida'
  },
  {
    'ine_region_code': '12',
    'ine_province_code': '27',
    'id': 29,
    'name_cadaster': 'LUGO',
    'name_es': 'Lugo',
    'name_ca': 'Lugo',
    'name_ine': 'Lugo'
  },
  {
    'ine_region_code': '13',
    'ine_province_code': '28',
    'id': 30,
    'name_cadaster': 'MADRID',
    'name_es': 'Madrid',
    'name_ca': 'Madrid',
    'name_ine': 'Madrid'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '29',
    'id': 31,
    'name_cadaster': 'MALAGA',
    'name_es': 'Málaga',
    'name_ca': 'Màlaga',
    'name_ine': 'Málaga'
  },
  {
    'ine_region_code': '14',
    'ine_province_code': '30',
    'id': 32,
    'name_cadaster': 'MURCIA',
    'name_es': 'Murcia',
    'name_ca': 'Múrcia',
    'name_ine': 'Murcia'
  },
  {
    'ine_region_code': '15',
    'ine_province_code': '31',
    'id': 33,
    'name_es': 'Navarra',
    'name_ca': 'Navarra',
    'name_ine': 'Navarra'
  },
  {
    'ine_region_code': '12',
    'ine_province_code': '32',
    'id': 34,
    'name_cadaster': 'OURENSE',
    'name_es': 'Orense',
    'name_ca': 'Ourense',
    'name_ine': 'Ourense'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '34',
    'id': 35,
    'name_cadaster': 'PALENCIA',
    'name_es': 'Palencia',
    'name_ca': 'Palència',
    'name_ine': 'Palencia'
  },
  {
    'ine_region_code': '05',
    'ine_province_code': '35',
    'id': 36,
    'name_cadaster': 'LAS PALMAS',
    'name_es': 'Palmas, Las',
    'name_ca': 'Palmas, Las',
    'name_ine': 'Palmas, Las'
  },
  {
    'ine_region_code': '12',
    'ine_province_code': '36',
    'id': 37,
    'name_cadaster': 'PONTEVEDRA',
    'name_es': 'Pontevedra',
    'name_ca': 'Pontevedra',
    'name_ine': 'Pontevedra'
  },
  {
    'ine_region_code': '17',
    'ine_province_code': '26',
    'id': 38,
    'name_cadaster': 'LA RIOJA',
    'name_es': 'Rioja, La',
    'name_ca': 'Rioja, La',
    'name_ine': 'Rioja, La'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '37',
    'id': 39,
    'name_cadaster': 'SALAMANCA',
    'name_es': 'Salamanca',
    'name_ca': 'Salamanca',
    'name_ine': 'Salamanca'
  },
  {
    'ine_region_code': '05',
    'ine_province_code': '38',
    'id': 40,
    'name_cadaster': 'S.C. TENERIFE',
    'name_es': 'Santa Cruz de Tenerife',
    'name_ca': 'Santa Cruz de Tenerife',
    'name_ine': 'Santa Cruz de Tenerife'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '40',
    'id': 41,
    'name_cadaster': 'SEGOVIA',
    'name_es': 'Segovia',
    'name_ca': 'Segòvia',
    'name_ine': 'Segovia'
  },
  {
    'ine_region_code': '01',
    'ine_province_code': '41',
    'id': 42,
    'name_cadaster': 'SEVILLA',
    'name_es': 'Sevilla',
    'name_ca': 'Sevilla',
    'name_ine': 'Sevilla'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '42',
    'id': 43,
    'name_cadaster': 'SORIA',
    'name_es': 'Soria',
    'name_ca': 'Sòria',
    'name_ine': 'Soria'
  },
  {
    'ine_region_code': '09',
    'ine_province_code': '43',
    'id': 44,
    'name_cadaster': 'TARRAGONA',
    'name_es': 'Tarragona',
    'name_ca': 'Tarragona',
    'name_ine': 'Tarragona'
  },
  {
    'ine_region_code': '02',
    'ine_province_code': '44',
    'id': 45,
    'name_cadaster': 'TERUEL',
    'name_es': 'Teruel',
    'name_ca': 'Teruel',
    'name_ine': 'Teruel'
  },
  {
    'ine_region_code': '08',
    'ine_province_code': '45',
    'id': 46,
    'name_cadaster': 'TOLEDO',
    'name_es': 'Toledo',
    'name_ca': 'Toledo',
    'name_ine': 'Toledo'
  },
  {
    'ine_region_code': '10',
    'ine_province_code': '46',
    'id': 47,
    'name_cadaster': 'VALENCIA',
    'name_es': 'Valencia',
    'name_ca': 'València',
    'name_ine': 'Valencia/València'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '47',
    'id': 48,
    'name_cadaster': 'VALLADOLID',
    'name_es': 'Valladolid',
    'name_ca': 'Valladolid',
    'name_ine': 'Valladolid'
  },
  {
    'ine_region_code': '07',
    'ine_province_code': '49',
    'id': 49,
    'name_cadaster': 'ZAMORA',
    'name_es': 'Zamora',
    'name_ca': 'Zamora',
    'name_ine': 'Zamora'
  },
  {
    'ine_region_code': '02',
    'ine_province_code': '50',
    'id': 50,
    'name_cadaster': 'ZARAGOZA',
    'name_es': 'Zaragoza',
    'name_ca': 'Saragossa',
    'name_ine': 'Zaragoza'
  },
  {
    'ine_region_code': '18',
    'ine_province_code': '51',
    'id': 51,
    'name_cadaster': 'CEUTA',
    'name_es': 'Ceuta',
    'name_ca': 'Ceuta',
    'name_ine': 'Ceuta'
  },
  {
    'ine_region_code': '19',
    'ine_province_code': '52',
    'id': 52,
    'name_cadaster': 'MELILLA',
    'name_es': 'Melilla',
    'name_ca': 'Melilla',
    'name_ine': 'Melilla'
  }
]



// WEBPACK FOOTER //
// ./src/options/spanish_provinces.js